// recon-supplier-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'rcu.flag.old': 'Item older than 90 days',
  'rcu.flag.overdue30': 'Overdue by more than 30 days',
  'rcu.flag.negative': 'Negative supplier balance',
  'rcu.flag.duplicate': 'Possible duplicate',
  'rcu.flag.partlyPaidOpen': 'Partly paid, still open',
  'rcu.flag.currency': 'Exchange rate needs checking',
  'rcu.flag.missingDoc': 'Missing voucher',
  'rcu.flag.paidAfter': 'Paid after the period date',
  'rcu.age.noDue': 'No due date',
  'rcu.age.notDue': 'Not yet due',
  'rcu.age.d1to30': '1–30 days overdue',
  'rcu.age.d31to60': '31–60 days overdue',
  'rcu.age.d61to90': '61–90 days overdue',
  'rcu.age.over90': 'Over 90 days overdue',
  'rcu.type.overpayment': 'Overpayment',
  'rcu.type.invoice': 'Invoice',
  'rcu.unknownSupplier': 'Unknown supplier',
  'rcu.type.supplierCredit': 'Supplier credit',
  'rcu.type.importedInvoice': 'Imported invoice',
  'rcu.importedItem': 'Imported item',
  'rcu.check.ledgerVsSubledger': 'General ledger vs subledger',
  'rcu.check.noControlAccount': 'No control account with a subledger in the area',
  'rcu.check.old': 'Items older than 90 days',
  'rcu.check.overdue30': 'Items overdue by more than 30 days',
  'rcu.check.negative': 'Negative supplier balances',
  'rcu.check.duplicates': 'Possible duplicates',
  'rcu.check.paymentsNoInvoice': 'Payments without an invoice',
  'rcu.check.partlyPaidOpen': 'Partly paid but still open',
  'rcu.check.currencyItems': 'Foreign-currency items to check',
  'rcu.check.directPostings': 'Direct postings on the control account',
  'rcu.check.missingDocs': 'Missing vouchers',
});
